import { useMemo } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

const usePlanStatus = () => {
  const { session } = useSelector((state) => state.session);

  const planInfo = useMemo(() => {
    if (!session) {
      return {
        status: null,
        isLoading: true,
        hasPlan: false,
        isTrial: false,
        isFree: false,
        planName: null,
        expirationDate: null,
        remainingDays: 0,
        paymentMethod: null,
      };
    }

    const typeUser = session?.my_user?.typeUser || [];
    const plans = (session?.plans?.plans|| []).filter((plan) => plan.category === "BASE");

    const isTrial = typeUser.includes("trial")

    const expirationDate = plans?.[0]?.next_charge
      ? moment(plans?.[0].next_charge).format("DD/MM/YYYY")
      : null;

    const remainingDays = plans?.[0]?.next_charge
      ? moment(plans?.[0]?.next_charge).diff(moment(), "days")
      : 0;

    const trialEndDate = session?.my_user?.date_created;
    const trialRemainingDays = trialEndDate
      ? 7 - moment().diff(moment(trialEndDate, "YYYY-MM-DD h:m:s"), "days")
      : 0;

    const trialExpirationDate = trialEndDate
      ? moment(trialEndDate, "YYYY-MM-DD h:m:s").add(7, "days").format("DD/MM/YYYY")
      : null;

    const lastBasePlan = session?.plans?.last_payment?.filter((p) => ["BASE", "TRIAL", "FREE"].indexOf(p.category) > -1 && p.status == "inactive").sort((a, b) => moment(b.next_charge) - moment(a.next_charge))

    let status = session.my_user.typePlan;

    const getExpirationDate = () => {
      if (isTrial) return trialExpirationDate
      if (expirationDate) return expirationDate
      if (lastBasePlan && lastBasePlan.length > 0) return moment(lastBasePlan[0].next_charge).format("DD/MM/YYYY")
    }

    const getPlanName = () => {
      if (isTrial) return "Plano Trial";

      const hasGold = plans.some((p) => p.product_id === 5);
      const hasSilver = plans.some((p) => p.product_id === 6);
      const hasBase = plans.some((p) => p.product_id === 2);

      if (hasGold && hasBase) return "Plano Ouro";
      if (hasSilver && hasBase) return "Plano Prata";
      if (hasBase) return "Plano Base";

      return plans?.[0]?.name
        ?.replace(/Usuários/gi, "")?.replace(/\b(10|20|30)\b/g, "")
        .replace(/\s+/g, " ")
        .trim()
    };

    return {
      status,
      isLoading: false,
      planName: getPlanName(),
      expirationDate: getExpirationDate(),
      remainingDays: isTrial ? trialRemainingDays : remainingDays,
      paymentMethod: plans?.payment_method || null,
    };
  }, [session]);

  return planInfo;
};

export default usePlanStatus;
